/*
 * Filter for options. It filter css option, as we need.
 */
export const baseFilterOptions = (options, type) => options.filter((item) => item.type === type);
export const baseFilterModelOptions = (options, parameter) =>
  options.filter((item) => item.parameter === parameter);

const convertHexToRGBA = (hex, opacity = 100) => {
  let tempHex = hex.replace("#", "");
  if (tempHex.length === 3) {
    tempHex += tempHex;
  }
  const r = parseInt(tempHex.substring(0, 2), 16);
  const g = parseInt(tempHex.substring(2, 4), 16);
  const b = parseInt(tempHex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity / 100})`;
};

/*
 * Return css expressions with html tags.
 */
export const baseCSSParametersHTMLImporatant = (parametersList, filter = false) => {
  const customCSSString =
    filter && parametersList.find((e) => e.parameter === "border-radius")
      ? `\n${hSpace(
          4
        )}<span class="atn">overflow</span><span class="pun">: </span><span class="atv">hidden</span>;`
      : "";
  return `${parametersList
    .map((item, index, arr) => {
      if (arr.length > 1 && arr.length - 1 === index) {
        return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value} !important</span>;`;
      } else if (arr.length === 1) {
        return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value} !important</span>;`;
      } else if (arr.length > 1 && index !== 0) {
        return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value} !important</span>;\n`;
      } else {
        return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value} !important</span>;\n`;
      }
    })
    .join("")}${customCSSString}`;
};

/*
 * Return css expressions with html tags.
 */
export const baseCSSParametersHTML = (parametersList, filter = false) => {
  const customCSSString =
    filter && parametersList.find((e) => e.parameter === "border-radius")
      ? `\n${hSpace(
          4
        )}<span class="atn">overflow</span><span class="pun">: </span><span class="atv">hidden</span>;`
      : "";
  return `${parametersList
    .map((item, index, arr) => {
      if (arr.length > 1 && arr.length - 1 === index) {
        return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value}</span>;`;
      } else if (arr.length === 1) {
        return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value}</span>;`;
      } else if (arr.length > 1 && index !== 0) {
        return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value}</span>;\n`;
      } else {
        return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
          item.separator
        } </span><span class="atv">${item.value}</span>;\n`;
      }
    })
    .join("")}${customCSSString}`;
};

/*
 * Return css properties in html tags.
 */
export const baseCSSStyleHTML = (css, parameters) => {
  return `\n<span class="codecssstyle">${hSpace(1)}${css} <span class="pun">{</span>\n${hSpace(
    1
  )}${parameters}\n${hSpace(1)}<span class="pun">}</span></span>`;
};

/*
 * Generate spaces
 */
export const hSpace = (count = 1) => {
  return Array.from({ length: count }, (_, i) => "&nbsp;").join("");
};

export const cSpace = (count = 1) => {
  return Array.from({ length: count }, (_, i) => " ").join("");
};

export const baseCSSParametersCodeImportant = (parametersList, filter = false) => {
  const customCSSString =
    filter && parametersList.find((e) => e.parameter === "border-radius")
      ? `\n${cSpace(4)}overflow:hidden;`
      : "";
  return `${parametersList
    .map((item, index, arr) => {
      if (arr.length > 1 && arr.length - 1 === index) {
        return `${cSpace(4)}${item.parameter}${item.separator}${item.value} !important;`;
      } else if (arr.length === 1) {
        return `${cSpace(2)}${item.parameter}${item.separator}${item.value} !important;`;
      } else if (arr.length > 1 && index !== 0) {
        return `${cSpace(4)}${item.parameter}${item.separator}${item.value} !important;\n`;
      } else {
        return `${cSpace(2)}${item.parameter}${item.separator}${item.value} !important;\n`;
      }
    })
    .join("")}${customCSSString}`;
};

/*
 * Return css properties in code.
 */
export const baseCSSParametersCode = (parametersList, filter = false) => {
  const customCSSString =
    filter && parametersList.find((e) => e.parameter === "border-radius")
      ? `\n${cSpace(4)}overflow:hidden;`
      : "";
  return `${parametersList
    .map((item, index, arr) => {
      if (arr.length > 1 && arr.length - 1 === index) {
        return `${cSpace(4)}${item.parameter}${item.separator}${item.value};`;
      } else if (arr.length === 1) {
        return `${cSpace(2)}${item.parameter}${item.separator}${item.value};`;
      } else if (arr.length > 1 && index !== 0) {
        return `${cSpace(4)}${item.parameter}${item.separator}${item.value};\n`;
      } else {
        return `${cSpace(2)}${item.parameter}${item.separator}${item.value};\n`;
      }
    })
    .join("")}${customCSSString}`;
};

/*
 * Return css expressions in code.
 */
export const baseCSSStyleCode = (css, parameters) =>
  `\n${cSpace(2)}${css} {\n${cSpace(2)}${parameters}\n${cSpace(2)}}`;

/*
 * Return css expressions in code.
 */
export const getIndexFromUrl = (src, url) => {
  const formattedUrl = url.replace("url(", "").replace(")", "");
  let currentIndex = 0;
  src.forEach((e, index) => {
    if (e.url === formattedUrl) {
      currentIndex = index;
    }
  });
  return currentIndex;
};

export const getIndexFromType = (src, type) => {
  let currentIndex = 0;
  src.forEach((e, index) => {
    if (e.value === type) {
      currentIndex = index;
    }
  });
  return currentIndex;
};

export const getCodeCSSFromOptions = (options, withtags = false) => {
  let arrowsIconStyle,
    arrowsIconOpacityStyle,
    arrowsBorderStyle,
    arrowsStyle,
    thumbnailsStyle,
    thumbnailsItemStyle,
    thumbnailsActiveItemStyle,
    thumbnailsNonActiveItemStyle,
    thumbnailsBorderRadiusStyle,
    mainBorderRadiusStyle,
    thumbnailsSMVItemStyle,
    thumbnailsVideoBlurStyle,
    thumbnailsSpinBlurStyle,
    thumbnailsShadowStyle,
    thumbnailsActiveShadowStyle,
    fullscreenIconOpenStyle,
    fullscreenIconColorStyle,
    fullscreenIconCloseStyle,
    fullscreenIconSizeStyle,
    fullscreenBackgroundStyle,
    spin360ThumbnailsWhiteStyle,
    hintIconsStyle,
    arrowsControlStyle,
    arrowsFSControlStyle,
    viewerLoadingStyle,
    spinLoadingStyle,
    videoIconStyle,
    modelIconStyle,
    modelThumbnailStyle,
    modelThumbnailStyle2 = "",
    videoPlayButtonStyle,
    videoPlayButtonHoverStyle,
    internalPadding,
    internalActivePadding,
    spinPosition,
    fadeInImageSpinStyle;

  let arrowsControlParameters = baseFilterOptions(options, "arrows-control"),
    arrowsFSControlParameters = baseFilterOptions(options, "fs-arrows-control"),
    arrowsIconParameters = baseFilterOptions(options, "arrows-icon"),
    arrowsIconOpacityParameters = baseFilterOptions(options, "arrows-icon-opacity"),
    arrowsBorderParameters = baseFilterOptions(options, "arrows-border"),
    arrowsParameters = baseFilterOptions(options, "arrows"),
    thumbnailsParameters = baseFilterOptions(options, "thumbnails"),
    fullscreenIconOpenParameters = baseFilterOptions(options, "fullscreen-icon-open"),
    fullscreenIconColorParameters = baseFilterOptions(options, "fullscreen-icon-color"),
    fullscreenIconCloseParameters = baseFilterOptions(options, "fullscreen-icon-close"),
    fullscreenIconSizeParameters = baseFilterOptions(options, "fullscreen-icon-size"),
    fullscreenBackgroundParameters = baseFilterOptions(options, "fullscreen-bg"),
    thumbnailsItemParameters = baseFilterOptions(options, "thumbnails-item"),
    thumbnailsActiveItemParameters = baseFilterOptions(options, "thumbnails-active-item"),
    thumbnailsNonActiveItemParameters = baseFilterOptions(options, "thumbnails-nonactive-item"),
    thumbnailsSMVItemParameters = baseFilterOptions(options, "thumbnails-item"),
    thumbnailsBorderRadiusParameters = baseFilterOptions(options, "thumbnails-border-radius"),
    thumbnailsBorderRadiusParametersWithoutOverflow = baseFilterOptions(
      options,
      "thumbnails-border-radius"
    ),
    mainBorderRadiusParameters = baseFilterOptions(options, "main-border-radius"),
    mainBorderRadiusParametersWithoutOverflow = baseFilterOptions(options, "main-border-radius"),
    thumbnailsVideoBlurParameters = baseFilterOptions(options, "thumbnails-video-blur"),
    thumbnailsSpinBlurParameters = baseFilterOptions(options, "thumbnails-spin-blur"),
    thumbnailsShadowParameters = baseFilterOptions(options, "thumbnails-box-shadows"),
    thumbnailsActiveShadowParameters = baseFilterOptions(options, "thumbnails-active-box-shadows"),
    spin360ThumbnailsWhiteParameters = baseFilterOptions(options, "spin360"),
    hintIconsParameters = baseFilterOptions(options, "hinticons"),
    hintCustomIconsParameters = baseFilterOptions(options, "hintcustomicons"),
    viewerLoadingParameters = baseFilterOptions(options, "viewer-loading"),
    spinLoadingParameters = baseFilterOptions(options, "spin-loading"),
    videoIconParameters = baseFilterOptions(options, "videoicon"),
    modelIconParameters = baseFilterOptions(options, "modelicon"),
    modelThumbnailParameters = baseFilterModelOptions(options, "model.thumbnail"),
    videoPlayButtonParameters = baseFilterOptions(options, "play-button"),
    videoPlayButtonHoverParameters = baseFilterOptions(options, "play-button-hover"),
    spinPositionParameters = baseFilterOptions(options, "spin-position"),
    fadeInImageSpinParameters = baseFilterOptions(options, "fadein-image-spin");

  let hintIconsTypes;

  if (hintIconsParameters && hintIconsParameters[0] && hintIconsParameters[0].hiddenType) {
    hintIconsTypes = hintIconsParameters[0].hiddenType;
  }

  if (withtags === true) {
    arrowsFSControlParameters = arrowsFSControlParameters
      .map((item, index, arr) => {
        if (arr.length - 1 === index) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${
            item.value === "true" ? "inline-block" : "none"
          } !important</span>;`;
        } else {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${
            item.value === "true" ? "inline-block" : "none"
          } !important</span>;\n`;
        }
      })
      .join("");

    arrowsControlParameters = arrowsControlParameters
      .map((item, index, arr) => {
        if (arr.length - 1 === index) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${
            item.value === "true" ? "block" : "none"
          } !important</span>;`;
        } else {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${
            item.value === "true" ? "block" : "none"
          } !important</span>;\n`;
        }
      })
      .join("");

    hintIconsParameters = baseCSSParametersHTML(hintIconsParameters);
    hintCustomIconsParameters = baseCSSParametersHTML(hintCustomIconsParameters);
    arrowsIconParameters = baseCSSParametersHTMLImporatant(arrowsIconParameters);
    arrowsIconOpacityParameters = baseCSSParametersHTMLImporatant(arrowsIconOpacityParameters);
    arrowsBorderParameters = baseCSSParametersHTMLImporatant(arrowsBorderParameters);

    arrowsParameters = arrowsParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background"
            ? `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`
            : `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value}</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;`;
        } else {
          return item.parameter === "background"
            ? `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`
            : `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value}</span>;\n`;
        }
      })
      .join("");

    spinPositionParameters = spinPositionParameters
      .map((item, index, arr) => {
        if (item.value === "top") {
          return (
            `${hSpace(2)}<span class="atn">${item.value}</span><span class="pun">${
              item.separator
            } </span><span class="atv">0 !important</span>;` +
            `${hSpace(2)}<span class="atn">transform</span><span class="pun">${
              item.separator
            } </span><span class="atv">translateY(0) !important</span>;`
          );
        }

        if (item.value === "center") {
          return (
            `${hSpace(2)}<span class="atn">top</span><span class="pun">${
              item.separator
            } </span><span class="atv">50% !important</span>;\n${hSpace(2)}` +
            `${hSpace(2)}<span class="atn">transform</span><span class="pun">${
              item.separator
            } </span><span class="atv">translateY(-50%) !important</span>;`
          );
        }

        if (item.value === "bottom") {
          return (
            `${hSpace(2)}<span class="atn">top</span><span class="pun">${
              item.separator
            } </span><span class="atv">auto !important</span>;\n${hSpace(2)}` +
            `${hSpace(2)}<span class="atn">${item.value}</span><span class="pun">${
              item.separator
            } </span><span class="atv">0 !important</span>;\n${hSpace(2)}` +
            `${hSpace(2)}<span class="atn">transform</span><span class="pun">${
              item.separator
            } </span><span class="atv">translateY(0) !important</span>;`
          );
        }
      })
      .join("");

    thumbnailsParameters = baseCSSParametersHTML(thumbnailsParameters);
    fullscreenBackgroundParameters = baseCSSParametersHTML(fullscreenBackgroundParameters);
    fullscreenIconColorParameters = baseCSSParametersHTML(fullscreenIconColorParameters);

    fullscreenIconOpenParameters = fullscreenIconOpenParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          if (item.parameter === "background-color") {
            return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value} !important</span>;`;
          }
          return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">url(${item.value}) !important</span>;`;
        } else if (arr.length === 1) {
          if (item.parameter === "background-color") {
            return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value} !important</span>;`;
          }
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">url(${item.value}) !important</span>;`;
        } else {
          if (item.parameter === "background-color") {
            return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value} !important</span>;\n`;
          }
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">url(${item.value}) !important</span>;\n`;
        }
      })
      .join("");

    fullscreenIconCloseParameters = fullscreenIconCloseParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">url(${item.value}) !important</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">url(${item.value}) !important</span>;`;
        } else {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">url(${item.value}) !important</span>;\n`;
        }
      })
      .join("");

    fullscreenIconSizeParameters = fullscreenIconSizeParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          let lines =
            `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value}</span>;\n` +
            `${hSpace(4)}<span class="atn">height</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value}</span>;`;
          return lines;
        } else {
          let lines =
            `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value}</span>;\n` +
            `${hSpace(4)}<span class="atn">height</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value}</span>;`;
          return lines;
        }
      })
      .join("");

    thumbnailsItemParameters = baseCSSParametersHTML(thumbnailsItemParameters);
    thumbnailsActiveItemParameters = baseCSSParametersHTML(thumbnailsActiveItemParameters);
    thumbnailsNonActiveItemParameters = baseCSSParametersHTML(thumbnailsNonActiveItemParameters);
    thumbnailsBorderRadiusParameters = baseCSSParametersHTML(
      thumbnailsBorderRadiusParameters,
      true
    );
    thumbnailsBorderRadiusParametersWithoutOverflow = baseCSSParametersHTML(
      thumbnailsBorderRadiusParametersWithoutOverflow
    );

    mainBorderRadiusParameters = baseCSSParametersHTML(mainBorderRadiusParameters, true);
    mainBorderRadiusParametersWithoutOverflow = baseCSSParametersHTML(
      mainBorderRadiusParametersWithoutOverflow
    );

    thumbnailsSMVItemParameters = thumbnailsSMVItemParameters
      .filter((item) => item.parameter !== "border-color")
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;`;
        } else {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;\n`;
        }
      })
      .join("");

    thumbnailsVideoBlurParameters = thumbnailsVideoBlurParameters
      .filter((item) => item.parameter === "filter" && item.type === "thumbnails-video-blur")
      .map((item) => {
        return (
          `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">blur(${item.value})</span>;\n` +
          `${hSpace(4)}<span class="atn">-webkit-filter</span><span class="pun">${
            item.separator
          } </span><span class="atv">blur(${item.value})</span>;`
        );
      })
      .join("");

    thumbnailsSpinBlurParameters = thumbnailsSpinBlurParameters
      .filter((item) => item.parameter === "filter" && item.type === "thumbnails-spin-blur")
      .map((item) => {
        return (
          `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">blur(${item.value})</span>;\n` +
          `${hSpace(4)}<span class="atn">-webkit-filter</span><span class="pun">${
            item.separator
          } </span><span class="atv">blur(${item.value})</span>;`
        );
      })
      .join("");

    if (thumbnailsShadowParameters.length) {
      const value = thumbnailsShadowParameters[0].value;
      const horizontalIndex = value.indexOf(" ");
      const sourceWithoutH = value.substr(horizontalIndex).trim();
      const verticalIndex = sourceWithoutH.indexOf(" ");
      const vertical = sourceWithoutH.substr(0, verticalIndex);
      const sourceWithoutV = sourceWithoutH.substr(verticalIndex).trim();
      const blurIndex = sourceWithoutV.indexOf(" ");
      const blurValue = sourceWithoutV.substr(0, blurIndex);
      const sourceWithoutBlur = sourceWithoutV.substr(blurIndex).trim();
      const stretchingIndex = sourceWithoutBlur.indexOf(" ");
      const stretching = sourceWithoutBlur.substr(0, stretchingIndex);
      const verticalInt = parseInt(vertical.replace("px", ""));
      const stretchingInt = parseInt(stretching.replace("px", ""));
      const blurInt = parseInt(blurValue.replace("px", ""));
      internalPadding = verticalInt + stretchingInt + blurInt;
    }

    thumbnailsShadowParameters = thumbnailsShadowParameters
      .filter((item) => item.parameter === "box-shadow" && item.type === "thumbnails-box-shadows")
      .map((item) => {
        return (
          `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;\n` +
          `${hSpace(4)}<span class="atn">-webkit-box-shadow</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;\n` +
          `${hSpace(4)}<span class="atn">-moz-box-shadow</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;`
        );
      })
      .join("");

    if (thumbnailsActiveShadowParameters.length) {
      const value = thumbnailsActiveShadowParameters[0].value;
      const horizontalIndex = value.indexOf(" ");
      const sourceWithoutH = value.substr(horizontalIndex).trim();
      const verticalIndex = sourceWithoutH.indexOf(" ");
      const vertical = sourceWithoutH.substr(0, verticalIndex);
      const sourceWithoutV = sourceWithoutH.substr(verticalIndex).trim();
      const blurIndex = sourceWithoutV.indexOf(" ");
      const blurValue = sourceWithoutV.substr(0, blurIndex);
      const sourceWithoutBlur = sourceWithoutV.substr(blurIndex).trim();
      const stretchingIndex = sourceWithoutBlur.indexOf(" ");
      const stretching = sourceWithoutBlur.substr(0, stretchingIndex);
      const verticalInt = parseInt(vertical.replace("px", ""));
      const stretchingInt = parseInt(stretching.replace("px", ""));
      const blurInt = parseInt(blurValue.replace("px", ""));
      internalActivePadding = verticalInt + stretchingInt + blurInt;
    }

    thumbnailsActiveShadowParameters = thumbnailsActiveShadowParameters
      .filter(
        (item) => item.parameter === "box-shadow" && item.type === "thumbnails-active-box-shadows"
      )
      .map((item) => {
        return (
          `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;\n` +
          `${hSpace(4)}<span class="atn">-webkit-box-shadow</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;\n` +
          `${hSpace(4)}<span class="atn">-moz-box-shadow</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value}</span>;`
        );
      })
      .join("");

    spin360ThumbnailsWhiteParameters = spin360ThumbnailsWhiteParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background-image"
            ? `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`
            : `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value} !important</span>;`;
        } else {
          return item.parameter === "background-image"
            ? `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`
            : `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`;
        }
      })
      .join("");

    videoIconParameters = videoIconParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background-image"
            ? `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`
            : `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value} !important</span>;`;
        } else {
          if (index === 0) {
            return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value} !important</span>;\n`;
          }

          return item.parameter === "background-image"
            ? `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`
            : `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`;
        }
      })
      .join("");

    modelThumbnailParameters = modelThumbnailParameters.map((item, index, arr) => {
      if (arr.length === 1) {
        return `${hSpace(1)}<span class="atn">--smv-model-icon</span><span class="pun">${
          item.separator
        } </span><span class="atv">url(${item.value}) !important</span>;`;
      }
    });

    modelIconParameters = modelIconParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background-image"
            ? `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`
            : `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value} !important</span>;`;
        } else {
          if (index === 0) {
            return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
              item.separator
            } </span><span class="atv">${item.value} !important</span>;\n`;
          }

          return item.parameter === "background-image"
            ? `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`
            : `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
                item.separator
              } </span><span class="atv">${item.value} !important</span>;\n`;
        }
      })
      .join("");

    viewerLoadingParameters = viewerLoadingParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value === "true" ? "block" : "none"}</span>;`;
        } else if (arr.length === 1) {
          return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value === "true" ? "block" : "none"}</span>;`;
        } else {
          return `${hSpace(4)}<span class="atn">${item.parameter}</span><span class="pun">${
            item.separator
          } </span><span class="atv">${item.value === "true" ? "block" : "none"}</span>;\n`;
        }
      })
      .join("");

    videoPlayButtonParameters = baseCSSParametersHTML(videoPlayButtonParameters);
    videoPlayButtonHoverParameters = baseCSSParametersHTML(videoPlayButtonHoverParameters);

    arrowsIconStyle = arrowsIconParameters.length
      ? baseCSSStyleHTML(
          ".smv-arrow .smv-icon::before, .smv-arrow .smv-icon::after",
          arrowsIconParameters
        )
      : "";
    arrowsIconOpacityStyle = arrowsIconOpacityParameters.length
      ? baseCSSStyleHTML(".smv-slides-box:hover .smv-button.smv-arrow", arrowsIconOpacityParameters)
      : "";
    arrowsBorderStyle = arrowsBorderParameters.length
      ? baseCSSStyleHTML(
          ".smv-h .smv-arrow::before, .smv-h .smv-arrow::after",
          arrowsBorderParameters
        )
      : "";
    arrowsStyle = arrowsParameters.length
      ? baseCSSStyleHTML(".smv-arrow-control .smv-arrow", arrowsParameters)
      : "";
    spinPosition = spinPositionParameters.length
      ? baseCSSStyleHTML(".sirv-hint", spinPositionParameters)
      : "";

    thumbnailsStyle = thumbnailsParameters.length
      ? baseCSSStyleHTML(".smv-thumbnails.smv-h", thumbnailsParameters)
      : "";
    fullscreenIconOpenStyle = fullscreenIconOpenParameters.length
      ? baseCSSStyleHTML(".smv-button-fullscreen-open .smv-icon", fullscreenIconOpenParameters)
      : "";
    fullscreenIconColorStyle = fullscreenIconColorParameters.length
      ? baseCSSStyleHTML(
          ".smv-button-fullscreen-open .smv-icon, .smv-button-fullscreen-close .smv-icon",
          fullscreenIconColorParameters
        )
      : "";
    fullscreenIconCloseStyle = fullscreenIconCloseParameters.length
      ? baseCSSStyleHTML(".smv-button-fullscreen-close .smv-icon", fullscreenIconCloseParameters)
      : "";
    fullscreenIconSizeStyle = fullscreenIconSizeParameters.length
      ? baseCSSStyleHTML(".smv .smv-button-fullscreen", fullscreenIconSizeParameters)
      : "";
    thumbnailsItemStyle = thumbnailsItemParameters.length
      ? baseCSSStyleHTML(
          ".smv-selectors-box.smv-thumbnails.smv-h .smv-item",
          thumbnailsItemParameters
        )
      : "";
    thumbnailsActiveItemStyle = thumbnailsActiveItemParameters.length
      ? baseCSSStyleHTML(
          ".smv-thumbnails .smv-item.smv-active .smv-selector",
          thumbnailsActiveItemParameters
        )
      : "";
    thumbnailsNonActiveItemStyle = thumbnailsNonActiveItemParameters.length
      ? baseCSSStyleHTML(
          ".smv-thumbnails .smv-item .smv-selector",
          thumbnailsNonActiveItemParameters
        )
      : "";

    fadeInImageSpinStyle =
      fadeInImageSpinParameters.length && fadeInImageSpinParameters[0].value === "false"
        ? getFadeInImageSpinWithTags(fadeInImageSpinParameters[0])
        : "";

    const thumbnailsDisabledPadding = `\n${hSpace(
      4
    )}<span class="atn">padding</span><span class="pun">: </span><span class="atv">0px</span>;`;

    const thumbnailsDisabledPositionOffset =
      `${hSpace(
        2
      )}<span class="atn">left</span><span class="pun">: </span><span class="atv">0</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">right</span><span class="pun">: </span><span class="atv">0</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">top</span><span class="pun">: </span><span class="atv">0</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">bottom</span><span class="pun">: </span><span class="atv">0</span>;`;

    thumbnailsBorderRadiusStyle = thumbnailsBorderRadiusParameters.length
      ? baseCSSStyleHTML(
          ".smv-thumbnails .smv-item .smv-selector",
          thumbnailsBorderRadiusParameters + thumbnailsDisabledPadding
        ) +
        `
      ${baseCSSStyleHTML(
        ".smv-thumbnails .smv-item .smv-selector:before, \n" +
          "  .smv-thumbnails .smv-item .smv-selector > div, \n" +
          "  .smv-thumbnails .smv-item .smv-selector > img",
        thumbnailsBorderRadiusParametersWithoutOverflow
      )}` +
        baseCSSStyleHTML(
          `.smv-thumbnails .smv-selector[data-type=spin]::before,\n` +
            `${hSpace(2)}.smv-thumbnails .smv-selector[data-type=video]::before,\n` +
            `${hSpace(2)}.smv-thumbnails .smv-selector[data-type=vimeo]::before,\n` +
            `${hSpace(2)}.smv-thumbnails .smv-selector[data-type=youtube]::before`,
          thumbnailsDisabledPositionOffset
        )
      : "";

    mainBorderRadiusStyle = mainBorderRadiusParameters.length
      ? baseCSSStyleHTML(
          ".smv-slides-box .smv-slides",
          mainBorderRadiusParameters + thumbnailsDisabledPadding
        )
      : "";

    mainBorderRadiusStyle = mainBorderRadiusParameters.length
      ? `\n${mainBorderRadiusStyle.replace(/^\s*\n/gm, "")}`
      : "";

    thumbnailsBorderRadiusStyle = thumbnailsBorderRadiusParameters.length
      ? `\n${thumbnailsBorderRadiusStyle.replace(/^\s*\n/gm, "")}`
      : "";

    thumbnailsSMVItemStyle = thumbnailsSMVItemParameters.length
      ? baseCSSStyleHTML(".smv-thumbnails .smv-item .smv-selector", thumbnailsSMVItemParameters)
      : "";
    thumbnailsVideoBlurStyle = thumbnailsVideoBlurParameters.length
      ? `${baseCSSStyleHTML(
          '.smv-item .smv-selector[data-type="video"] > div,\n' +
            '  .smv-item .smv-selector[data-type="video"] > img',
          thumbnailsVideoBlurParameters
        )}${baseCSSStyleHTML(
          '.smv-item .smv-selector[data-type="video"]',
          '  <span class="atn">overflow</span><span class="pun">: </span><span class="atv">hidden</span>;'
        )}`
      : "";
    thumbnailsSpinBlurStyle = thumbnailsSpinBlurParameters.length
      ? `${baseCSSStyleHTML(
          '.smv-item .smv-selector[data-type="spin"] > div,\n' +
            '  .smv-item .smv-selector[data-type="spin"] > img',
          thumbnailsSpinBlurParameters
        )}`
      : "";

    thumbnailsSpinBlurStyle = thumbnailsSpinBlurParameters.length
      ? `\n${thumbnailsSpinBlurStyle.replace(/^\s*\n/gm, "")}`
      : "";

    thumbnailsVideoBlurStyle = thumbnailsVideoBlurParameters.length
      ? `\n${thumbnailsVideoBlurStyle.replace(/^\s*\n/gm, "")}`
      : "";

    const thumbnailsShadowStyleAfter =
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">: </span><span class="atv">''</span>;\n` +
      `${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">: </span><span class="atv">absolute</span>;\n` +
      `${hSpace(
        4
      )}<span class="atn">top</span><span class="pun">: </span><span class="atv">0</span>;\n` +
      `${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">: </span><span class="atv">0</span>;\n` +
      `${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">: </span><span class="atv">100%</span>;\n` +
      `${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">: </span><span class="atv">100%</span>;\n` +
      `${hSpace(
        4
      )}<span class="atn">z-index</span><span class="pun">: </span><span class="atv">2</span>;`;

    const internalPaddingString = `${hSpace(
      2
    )}<span class="atn">padding</span><span class="pun">: </span><span class="atv">${internalPadding}px 0</span>;`;
    const internalActivePaddingString = `${hSpace(
      2
    )}<span class="atn">padding</span><span class="pun">: </span><span class="atv">${internalActivePadding}px 0</span>;`;

    thumbnailsShadowStyle =
      thumbnailsShadowParameters.length && thumbnailsShadowParameters.indexOf("inset") === -1
        ? `${baseCSSStyleHTML(
            ".smv-thumbnails .smv-item .smv-selector",
            thumbnailsShadowParameters
          )}` +
          `${baseCSSStyleHTML(".smv-selectors-box .smv-selectors .smv-ss", internalPaddingString)}`
        : thumbnailsShadowParameters.length && thumbnailsShadowParameters.indexOf("inset") !== -1
        ? `${baseCSSStyleHTML(
            ".smv-thumbnails .smv-item .smv-selector::after",
            thumbnailsShadowParameters + thumbnailsShadowStyleAfter
          )}`
        : "";

    thumbnailsActiveShadowStyle =
      thumbnailsActiveShadowParameters.length &&
      thumbnailsActiveShadowParameters.indexOf("inset") === -1
        ? `${baseCSSStyleHTML(
            ".smv-thumbnails .smv-item.smv-active .smv-selector",
            thumbnailsActiveShadowParameters
          )}` +
          `${baseCSSStyleHTML(
            ".smv-selectors-box .smv-selectors .smv-ss",
            internalActivePaddingString
          )}`
        : thumbnailsActiveShadowParameters.length &&
          thumbnailsActiveShadowParameters.indexOf("inset") !== -1
        ? `${baseCSSStyleHTML(
            ".smv-thumbnails .smv-item.smv-active .smv-selector::after",
            thumbnailsActiveShadowParameters + thumbnailsShadowStyleAfter
          )}`
        : "";

    spin360ThumbnailsWhiteStyle = spin360ThumbnailsWhiteParameters.length
      ? baseCSSStyleHTML(
          '.smv-thumbnails .smv-selector[data-type="spin"]:before',
          spin360ThumbnailsWhiteParameters
        )
      : "";
    viewerLoadingStyle = viewerLoadingParameters.length
      ? [imageFadeIn(), baseCSSStyleHTML(".smv-component-loader", viewerLoadingParameters)].join(
          "\n"
        )
      : "";
    spinLoadingStyle =
      spinLoadingParameters.length && spinLoadingParameters[0].value === "false"
        ? baseCSSStyleHTML(
            ".smv-loader.spin-loader.smv-progress-loader",
            `${hSpace(2)}<span class="atn">${
              spinLoadingParameters[0].parameter
            }</span><span class="pun">${
              spinLoadingParameters[0].separator
            } </span><span class="atv">none</span>;`
          )
        : "";
    videoIconStyle = videoIconParameters.length
      ? baseCSSStyleHTML(
          '.smv-thumbnails .smv-selector[data-type="video"]:before',
          videoIconParameters
        )
      : "";

    modelThumbnailStyle = modelThumbnailParameters.length
      ? baseCSSStyleHTML(".Sirv", modelThumbnailParameters)
      : "";
    modelIconStyle = modelIconParameters.length
      ? baseCSSStyleHTML(
          '.smv-thumbnails .smv-selector[data-type="model"]:before',
          modelIconParameters
        )
      : "";
    fullscreenBackgroundStyle = fullscreenBackgroundParameters.length
      ? baseCSSStyleHTML(".smv-fullscreen-box", fullscreenBackgroundParameters)
      : "";
    videoPlayButtonStyle = videoPlayButtonParameters.length
      ? baseCSSStyleHTML(
          ".smv .smv-sirv-video.video-js .vjs-big-play-button",
          videoPlayButtonParameters
        )
      : "";
    videoPlayButtonHoverStyle = videoPlayButtonHoverParameters.length
      ? baseCSSStyleHTML(
          ".smv-sirv-video.video-js:hover .vjs-big-play-button,\n" +
            "  .smv-sirv-video.video-js .vjs-big-play-button:focus",
          videoPlayButtonHoverParameters
        )
      : "";

    if (hintIconsTypes === "horizontal_arrows" || hintIconsTypes === "horizontal_vertical_arrows") {
      hintIconsStyle = hintIconsParameters.length
        ? `<span class="codecssstyle">` +
          `\n${hSpace(
            2
          )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message  <span class="pun">{</span>` +
          `\n${hSpace(
            4
          )}<span class="atn">display</span><span class="pun">:</span><span class="atv"> none</span>;` +
          `\n${hSpace(2)}<span class="pun">}</>\n</span>` +
          `${hSpace(2)}.sirv-hint.spin-hint-horizontal-animation <span class="pun">{</span>` +
          `\n${hSpace(
            4
          )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 100%</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 90px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> 240px auto</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 0</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">bottom</span><span class="pun">:</span><span class="atv"> 0</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">z-index</span><span class="pun">:</span><span class="atv"> 10</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
          getHintCustomIconHTML(hintIconsTypes) +
          `\n${hSpace(2)}<span class="pun">}</span>`
        : "";
    } else if (hintIconsTypes === "text_left_right") {
      hintIconsStyle = hintIconsParameters.length
        ? `<span class="codecssstyle">` +
          `\n${hSpace(2)}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::before,\n` +
          `${hSpace(
            2
          )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after <span class="pun">{</span>` +
          `\n${hSpace(
            4
          )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 10px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 8px</span>;` +
          getBeforeHintIconHTML(hintIconsTypes) +
          `\n${hSpace(
            4
          )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateY(-50%)</span>;` +
          `\n${hSpace(2)}${hintIconsParameters}` +
          `\n${hSpace(2)}<span class="pun">}</span>` +
          `\n${hSpace(
            2
          )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after <span class="pun">{</span>` +
          `\n${hSpace(
            4
          )}<span class="atn">right</span><span class="pun">:</span><span class="atv"> 8px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> auto</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateY(-50%) rotate(180deg)</span>;` +
          getAfterHintIconHTML(hintIconsTypes) +
          `\n${hSpace(2)}<span class="pun">}</span>\n` +
          addedPaddingToHintMessageHTML(hintIconsTypes) +
          getTopBottomHintIconHTML(hintIconsTypes)
        : "";
    } else {
      hintIconsStyle = hintIconsParameters.length
        ? `<span class="codecssstyle">` +
          `\n${hSpace(2)}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::before,\n` +
          `${hSpace(
            2
          )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after <span class="pun">{</span>` +
          `\n${hSpace(
            4
          )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 10px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 8px</span>;` +
          getBeforeHintIconHTML(hintIconsTypes) +
          `\n${hSpace(
            4
          )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
          `\n${hSpace(2)}${hintIconsParameters}` +
          `\n${hSpace(2)}<span class="pun">}</span>` +
          `\n${hSpace(
            2
          )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after <span class="pun">{</span>` +
          `\n${hSpace(
            4
          )}<span class="atn">right</span><span class="pun">:</span><span class="atv"> 8px</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> auto</span>;` +
          `\n${hSpace(
            4
          )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateY(-50%) rotate(180deg)</span>;` +
          getAfterHintIconHTML(hintIconsTypes) +
          `\n${hSpace(2)}<span class="pun">}</span>\n` +
          addedPaddingToHintMessageHTML(hintIconsTypes) +
          getTopBottomHintIconHTML(hintIconsTypes)
        : "";
    }

    arrowsControlStyle = arrowsControlParameters.length
      ? `\n<span class="codecssstyle">${hSpace(
          2
        )}.Sirv .smv-arrow-control  <span class="pun">{</span>\n${hSpace(
          2
        )}${arrowsControlParameters}\n${hSpace(2)}<span class="pun">}</span>`
      : "";
    arrowsFSControlStyle = arrowsFSControlParameters.length
      ? `\n<span class="codecssstyle">${hSpace(
          2
        )}.smv-fullscreen-box .smv-arrow-control  <span class="pun">{</span>\n${hSpace(
          2
        )}${arrowsFSControlParameters}\n${hSpace(2)}<span class="pun">}</span>`
      : "";
  } else {
    arrowsFSControlParameters = arrowsFSControlParameters
      .map((item, index, arr) => {
        if (arr.length - 1 === index) {
          return `${cSpace(2)}${item.parameter}${item.separator}${
            item.value === "true" ? "inline-block" : "none"
          } !important;`;
        } else {
          return `${cSpace(2)}${item.parameter}${item.separator}${
            item.value === "true" ? "inline-block" : "none"
          } !important;\n`;
        }
      })
      .join("");

    arrowsControlParameters = arrowsControlParameters
      .map((item, index, arr) => {
        if (arr.length - 1 === index) {
          return `${cSpace(2)}${item.parameter}${item.separator}${
            item.value === "true" ? "block" : "none"
          } !important;`;
        } else {
          return `${cSpace(2)}${item.parameter}${item.separator}${
            item.value === "true" ? "block" : "none"
          } !important;\n`;
        }
      })
      .join("");

    hintIconsParameters = baseCSSParametersCode(hintIconsParameters);
    hintCustomIconsParameters = baseCSSParametersCode(hintCustomIconsParameters);
    arrowsIconParameters = baseCSSParametersCodeImportant(arrowsIconParameters);
    arrowsIconOpacityParameters = baseCSSParametersCodeImportant(arrowsIconOpacityParameters);
    arrowsBorderParameters = baseCSSParametersCodeImportant(arrowsBorderParameters);
    fullscreenBackgroundParameters = baseCSSParametersCode(fullscreenBackgroundParameters);
    fullscreenIconColorParameters = baseCSSParametersCode(fullscreenIconColorParameters);

    arrowsParameters = arrowsParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background"
            ? `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`
            : `${cSpace(4)}${item.parameter}${item.separator} ${item.value};`;
        } else if (arr.length === 1) {
          return `${cSpace(2)}${item.parameter}${item.separator} ${item.value};`;
        } else {
          return item.parameter === "background"
            ? `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;\n`
            : `${cSpace(2)}${item.parameter}${item.separator} ${item.value};\n`;
        }
      })
      .join("");

    thumbnailsParameters = baseCSSParametersCode(thumbnailsParameters);
    fullscreenIconOpenParameters = fullscreenIconOpenParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          if (item.parameter === "background-color") {
            return `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`;
          }
          return `${cSpace(4)}${item.parameter}${item.separator} url(${item.value}) !important;`;
        } else if (arr.length === 1) {
          if (item.parameter === "background-color") {
            return `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`;
          }
          return `${cSpace(2)}${item.parameter}${item.separator} url(${item.value}) !important;`;
        } else {
          if (item.parameter === "background-color") {
            return `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;\n`;
          }
          return `${cSpace(2)}${item.parameter}${item.separator} url(${item.value}) !important;\n`;
        }
      })
      .join("");

    fullscreenIconCloseParameters = fullscreenIconCloseParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return `${cSpace(4)}${item.parameter}${item.separator} url(${item.value}) !important;`;
        } else if (arr.length === 1) {
          return `${cSpace(2)}${item.parameter}${item.separator} url(${item.value}) !important;`;
        } else {
          return `${cSpace(2)}${item.parameter}${item.separator} url(${item.value}) !important;\n`;
        }
      })
      .join("");

    fullscreenIconSizeParameters = fullscreenIconSizeParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          let lines =
            `${cSpace(4)}${item.parameter}${item.separator} ${item.value};\n` +
            `${cSpace(4)}height${item.separator} ${item.value};`;
          return lines;
        } else {
          let lines =
            `${cSpace(2)}${item.parameter}${item.separator} ${item.value};\n` +
            `${cSpace(4)}height${item.separator} ${item.value};`;
          return lines;
        }
      })
      .join("");

    thumbnailsItemParameters = baseCSSParametersCode(thumbnailsItemParameters);
    thumbnailsActiveItemParameters = baseCSSParametersCode(thumbnailsActiveItemParameters);
    thumbnailsNonActiveItemParameters = baseCSSParametersCode(thumbnailsNonActiveItemParameters);
    thumbnailsBorderRadiusParameters = baseCSSParametersCode(
      thumbnailsBorderRadiusParameters,
      true
    );
    thumbnailsBorderRadiusParametersWithoutOverflow = baseCSSParametersCode(
      thumbnailsBorderRadiusParametersWithoutOverflow
    );

    mainBorderRadiusParameters = baseCSSParametersCode(mainBorderRadiusParameters, true);
    mainBorderRadiusParametersWithoutOverflow = baseCSSParametersCode(
      mainBorderRadiusParametersWithoutOverflow
    );

    thumbnailsSMVItemParameters = thumbnailsSMVItemParameters
      .filter((item) => item.parameter !== "border-color")
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return `${cSpace(4)}${item.parameter}${item.separator} ${item.value};`;
        } else if (arr.length === 1) {
          return `${cSpace(2)}${item.parameter}${item.separator} ${item.value};`;
        } else {
          return `${cSpace(2)}${item.parameter}${item.separator} ${item.value};\n`;
        }
      })
      .join("");

    thumbnailsVideoBlurParameters = thumbnailsVideoBlurParameters
      .filter((item) => item.parameter === "filter" && item.type === "thumbnails-video-blur")
      .map((item) => {
        return (
          `${cSpace(2)}${item.parameter}${item.separator} blur(${item.value});\n` +
          `${cSpace(4)}-webkit-filter${item.separator} blur(${item.value});`
        );
      })
      .join("");

    thumbnailsSpinBlurParameters = thumbnailsSpinBlurParameters
      .filter((item) => item.parameter === "filter" && item.type === "thumbnails-spin-blur")
      .map((item) => {
        return (
          `${cSpace(2)}${item.parameter}${item.separator} blur(${item.value});\n` +
          `${cSpace(4)}-webkit-filter${item.separator} blur(${item.value});`
        );
      })
      .join("");

    if (thumbnailsShadowParameters.length) {
      const value = thumbnailsShadowParameters[0].value;
      const horizontalIndex = value.indexOf(" ");
      const sourceWithoutH = value.substr(horizontalIndex).trim();
      const verticalIndex = sourceWithoutH.indexOf(" ");
      const vertical = sourceWithoutH.substr(0, verticalIndex);
      const sourceWithoutV = sourceWithoutH.substr(verticalIndex).trim();
      const blurIndex = sourceWithoutV.indexOf(" ");
      const blurValue = sourceWithoutV.substr(0, blurIndex);
      const sourceWithoutBlur = sourceWithoutV.substr(blurIndex).trim();
      const stretchingIndex = sourceWithoutBlur.indexOf(" ");
      const stretching = sourceWithoutBlur.substr(0, stretchingIndex);
      const verticalInt = parseInt(vertical.replace("px", ""));
      const stretchingInt = parseInt(stretching.replace("px", ""));
      const blurInt = parseInt(blurValue.replace("px", ""));

      internalPadding = verticalInt + stretchingInt + blurInt;
    }

    thumbnailsShadowParameters = thumbnailsShadowParameters
      .filter((item) => item.parameter === "box-shadow" && item.type === "thumbnails-box-shadows")
      .map((item) => {
        return (
          `${cSpace(2)}${item.parameter}${item.separator} ${item.value};\n` +
          `${cSpace(4)}-webkit-box-shadow${item.separator} ${item.value};\n` +
          `${cSpace(4)}-moz-box-shadow${item.separator} ${item.value};`
        );
      })
      .join("");

    if (thumbnailsActiveShadowParameters.length) {
      const value = thumbnailsActiveShadowParameters[0].value;
      const horizontalIndex = value.indexOf(" ");
      const sourceWithoutH = value.substr(horizontalIndex).trim();
      const verticalIndex = sourceWithoutH.indexOf(" ");
      const vertical = sourceWithoutH.substr(0, verticalIndex);
      const sourceWithoutV = sourceWithoutH.substr(verticalIndex).trim();
      const blurIndex = sourceWithoutV.indexOf(" ");
      const blurValue = sourceWithoutV.substr(0, blurIndex);
      const sourceWithoutBlur = sourceWithoutV.substr(blurIndex).trim();
      const stretchingIndex = sourceWithoutBlur.indexOf(" ");
      const stretching = sourceWithoutBlur.substr(0, stretchingIndex);
      const verticalInt = parseInt(vertical.replace("px", ""));
      const stretchingInt = parseInt(stretching.replace("px", ""));
      const blurInt = parseInt(blurValue.replace("px", ""));

      internalActivePadding = verticalInt + stretchingInt + blurInt;
    }

    thumbnailsActiveShadowParameters = thumbnailsActiveShadowParameters
      .filter(
        (item) => item.parameter === "box-shadow" && item.type === "thumbnails-active-box-shadows"
      )
      .map((item) => {
        return (
          `${cSpace(2)}${item.parameter}${item.separator} ${item.value};\n` +
          `${cSpace(4)}-webkit-box-shadow${item.separator} ${item.value};\n` +
          `${cSpace(4)}-moz-box-shadow${item.separator} ${item.value};`
        );
      })
      .join("");

    spin360ThumbnailsWhiteParameters = spin360ThumbnailsWhiteParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background-image"
            ? `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`
            : `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`;
        } else if (arr.length === 1) {
          return `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;`;
        } else {
          return item.parameter === "background-image"
            ? `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;\n`
            : `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;\n`;
        }
      })
      .join("");

    videoIconParameters = videoIconParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background-image"
            ? `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`
            : `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`;
        } else if (arr.length === 1) {
          return `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;`;
        } else {
          if (index === 0) {
            return `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;\n`;
          }

          return item.parameter === "background-image"
            ? `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;\n`
            : `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;\n`;
        }
      })
      .join("");

    let modelThumbnailParameters2 = modelThumbnailParameters.map((item, index, arr) => {
      if (arr.length === 1) {
        return item.value.indexOf("black") !== -1
          ? `background-color: #fff !important;`
          : "background-color: #373a3cb3 !important;";
      }
    });

    modelThumbnailStyle2 = modelThumbnailParameters.length
      ? baseCSSStyleCode(
          '.smv-thumbnails .smv-selector[data-type="model"]:before',
          modelThumbnailParameters2
        )
      : "";

    modelThumbnailParameters = modelThumbnailParameters.map((item, index, arr) => {
      if (arr.length === 1) {
        return `${cSpace(2)}--smv-model-icon${item.separator} url(${item.value}) !important;`;
      }
    });

    modelIconParameters = modelIconParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return item.parameter === "background-image"
            ? `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`
            : `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;`;
        } else if (arr.length === 1) {
          return (
            `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;` +
            (item.value.indexOf("black") !== -1
              ? `background-color: #fff !important;`
              : "background-color: #373a3cb3 !important;")
          );
        } else {
          if (index === 0) {
            return `${cSpace(2)}${item.parameter}${item.separator} ${item.value} !important;\n`;
          }

          return item.parameter === "background-image"
            ? `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;\n`
            : `${cSpace(4)}${item.parameter}${item.separator} ${item.value} !important;\n`;
        }
      })
      .join("");

    viewerLoadingParameters = viewerLoadingParameters
      .map((item, index, arr) => {
        if (arr.length > 1 && arr.length - 1 === index) {
          return `${cSpace(2)}${item.parameter}${item.separator}${
            item.value === "true" ? " block" : " none"
          };`;
        } else if (arr.length === 1) {
          return `${cSpace(2)}${item.parameter}${item.separator}${
            item.value === "true" ? " block" : " none"
          };`;
        } else {
          return `${cSpace(4)}${item.parameter}${item.separator}${
            item.value === "true" ? " block" : " none"
          };\n`;
        }
      })
      .join("");

    spinPositionParameters = spinPositionParameters
      .map((item, index, arr) => {
        if (item.value === "top") {
          return `\n${cSpace(4)}top: 0 !important;\ntransform: translate(0) !important;`;
        }

        if (item.value === "center") {
          return `\n${cSpace(4)}top: 50% !important;\ntransform: translateY(-50%) !important;`;
        }

        if (item.value === "bottom") {
          return `\n${cSpace(
            4
          )}top: auto !important;\nbottom: 0 !important; transform: translateY(0) !important;`;
        }
      })
      .join("");

    videoPlayButtonParameters = baseCSSParametersCode(videoPlayButtonParameters);
    videoPlayButtonHoverParameters = baseCSSParametersCode(videoPlayButtonHoverParameters);

    arrowsStyle = arrowsParameters.length
      ? baseCSSStyleCode(".smv-arrow-control .smv-arrow", arrowsParameters)
      : "";
    arrowsIconOpacityStyle = arrowsIconOpacityParameters.length
      ? baseCSSStyleCode(".smv-slides-box:hover .smv-button.smv-arrow", arrowsIconOpacityParameters)
      : "";
    arrowsIconStyle = arrowsIconParameters.length
      ? baseCSSStyleCode(
          ".smv-arrow .smv-icon::before, .smv-arrow .smv-icon::after",
          arrowsIconParameters
        )
      : "";
    arrowsBorderStyle = arrowsBorderParameters.length
      ? baseCSSStyleCode(
          ".smv-h .smv-arrow::before, .smv-h .smv-arrow::after",
          arrowsBorderParameters
        )
      : "";
    thumbnailsStyle = thumbnailsParameters.length
      ? baseCSSStyleCode(".smv-thumbnails.smv-h", thumbnailsParameters)
      : "";
    fullscreenIconOpenStyle = fullscreenIconOpenParameters.length
      ? baseCSSStyleCode(".smv-button-fullscreen-open .smv-icon", fullscreenIconOpenParameters)
      : "";
    fullscreenIconColorStyle = fullscreenIconColorParameters.length
      ? baseCSSStyleCode(
          ".smv-button-fullscreen-open .smv-icon, .smv-button-fullscreen-close .smv-icon",
          fullscreenIconColorParameters
        )
      : "";
    fullscreenIconCloseStyle = fullscreenIconCloseParameters.length
      ? baseCSSStyleCode(".smv-button-fullscreen-close .smv-icon", fullscreenIconCloseParameters)
      : "";
    fullscreenIconSizeStyle = fullscreenIconSizeParameters.length
      ? baseCSSStyleCode(".smv .smv-button-fullscreen", fullscreenIconSizeParameters)
      : "";
    thumbnailsItemStyle = thumbnailsItemParameters.length
      ? baseCSSStyleCode(
          ".smv-selectors-box.smv-thumbnails.smv-h .smv-item",
          thumbnailsItemParameters
        )
      : "";
    thumbnailsActiveItemStyle = thumbnailsActiveItemParameters.length
      ? baseCSSStyleCode(
          ".smv-thumbnails .smv-item.smv-active .smv-selector",
          thumbnailsActiveItemParameters
        )
      : "";
    thumbnailsNonActiveItemStyle = thumbnailsNonActiveItemParameters.length
      ? baseCSSStyleCode(
          ".smv-thumbnails .smv-item .smv-selector",
          thumbnailsNonActiveItemParameters
        )
      : "";
    spinPosition = spinPositionParameters.length
      ? baseCSSStyleCode(".sirv-hint", spinPositionParameters)
      : "";

    const thumbnailsDisabledPadding = `\n${cSpace(4)}padding: 0px;`;

    const thumbnailsDisabledPositionOffset =
      `${cSpace(2)}left: 0;` +
      `\n${cSpace(4)}right: 0;` +
      `\n${cSpace(4)}top: 0;` +
      `\n${cSpace(4)}bottom: 0;`;

    thumbnailsBorderRadiusStyle = thumbnailsBorderRadiusParameters.length
      ? `${baseCSSStyleCode(
          ".smv-thumbnails .smv-item .smv-selector",
          thumbnailsBorderRadiusParameters + thumbnailsDisabledPadding
        )}
       ${baseCSSStyleCode(
         ".smv-thumbnails .smv-item .smv-selector::before, \n" +
           "  .smv-thumbnails .smv-item .smv-selector > div \n" +
           "  .smv-thumbnails .smv-item .smv-selector > img",
         thumbnailsBorderRadiusParametersWithoutOverflow
       )}` +
        baseCSSStyleCode(
          `.smv-thumbnails .smv-selector[data-type=spin]::before,\n` +
            `  .smv-thumbnails .smv-selector[data-type=video]::before,\n` +
            `  .smv-thumbnails .smv-selector[data-type=vimeo]::before,\n` +
            `  .smv-thumbnails .smv-selector[data-type=youtube]::before`,
          thumbnailsDisabledPositionOffset
        )
      : "";

    thumbnailsBorderRadiusStyle = thumbnailsBorderRadiusParameters.length
      ? `\n${thumbnailsBorderRadiusStyle.replace(/^\s*\n/gm, "")}`
      : "";

    mainBorderRadiusStyle = mainBorderRadiusParameters.length
      ? `${baseCSSStyleCode(
          ".smv-slides-box .smv-slides",
          mainBorderRadiusParameters + thumbnailsDisabledPadding
        )}`
      : "";

    mainBorderRadiusStyle = mainBorderRadiusParameters.length
      ? `\n${mainBorderRadiusStyle.replace(/^\s*\n/gm, "")}`
      : "";

    thumbnailsSMVItemStyle = thumbnailsSMVItemParameters.length
      ? baseCSSStyleCode(".smv-thumbnails .smv-item .smv-selector", thumbnailsSMVItemParameters)
      : "";
    thumbnailsVideoBlurStyle = thumbnailsVideoBlurParameters.length
      ? `${baseCSSStyleCode(
          ".smv-thumbnails .smv-selector[data-type=video] > div,\n" +
            "  .smv-thumbnails .smv-selector[data-type=video] > img",
          thumbnailsVideoBlurParameters
        )}
      ${baseCSSStyleCode(
        ".smv-thumbnails .smv-selector[data-type=video]",
        `${cSpace(2)}overflow: hidden;`
      )}`
      : "";
    thumbnailsSpinBlurStyle = thumbnailsSpinBlurParameters.length
      ? `${baseCSSStyleCode(
          ".smv-thumbnails .smv-selector[data-type=spin] > div,\n" +
            "  .smv-thumbnails .smv-selector[data-type=spin] > img",
          thumbnailsSpinBlurParameters
        )}`
      : "";

    thumbnailsVideoBlurStyle = thumbnailsVideoBlurParameters.length
      ? `\n${thumbnailsVideoBlurStyle.replace(/^\s*\n/gm, "")}`
      : "";

    thumbnailsSpinBlurStyle = thumbnailsSpinBlurParameters.length
      ? `\n${thumbnailsSpinBlurStyle.replace(/^\s*\n/gm, "")}`
      : "";

    const thumbnailsShadowAfter =
      `\n${cSpace(4)}content: "";\n` +
      `${cSpace(4)}position: absolute;\n` +
      `${cSpace(4)}top: 0;\n` +
      `${cSpace(4)}left: 0;\n` +
      `${cSpace(4)}width: 100%;\n` +
      `${cSpace(4)}height: 100%;\n` +
      `${cSpace(4)}z-index: 2;`;

    const internalPaddingString = `${cSpace(2)}padding: ${internalPadding}px 0;`;
    const internalActivePaddingString = `${cSpace(2)}padding: ${internalActivePadding}px 0;`;

    thumbnailsShadowStyle =
      thumbnailsShadowParameters.length && thumbnailsShadowParameters.indexOf("inset") === -1
        ? `${baseCSSStyleCode(
            ".smv-thumbnails .smv-item .smv-selector",
            thumbnailsShadowParameters
          )}` +
          `${baseCSSStyleCode(".smv-selectors-box .smv-selectors .smv-ss", internalPaddingString)}`
        : thumbnailsShadowParameters.length && thumbnailsShadowParameters.indexOf("inset") !== -1
        ? `${baseCSSStyleCode(
            ".smv-thumbnails .smv-item .smv-selector::after",
            thumbnailsShadowParameters + thumbnailsShadowAfter
          )}`
        : "";

    thumbnailsActiveShadowStyle =
      thumbnailsActiveShadowParameters.length &&
      thumbnailsActiveShadowParameters.indexOf("inset") === -1
        ? `${baseCSSStyleCode(
            ".smv-thumbnails .smv-item.smv-active .smv-selector",
            thumbnailsActiveShadowParameters
          )}` +
          `${baseCSSStyleCode(
            ".smv-selectors-box .smv-selectors .smv-ss",
            internalActivePaddingString
          )}`
        : thumbnailsActiveShadowParameters.length &&
          thumbnailsActiveShadowParameters.indexOf("inset") !== -1
        ? `${baseCSSStyleCode(
            ".smv-thumbnails .smv-item.smv-active .smv-selector::after",
            thumbnailsActiveShadowParameters + thumbnailsShadowAfter
          )}`
        : "";

    spin360ThumbnailsWhiteStyle = spin360ThumbnailsWhiteParameters.length
      ? baseCSSStyleCode(
          '.smv-thumbnails .smv-selector[data-type="spin"]:before',
          spin360ThumbnailsWhiteParameters
        )
      : "";
    viewerLoadingStyle = viewerLoadingParameters.length
      ? [
          baseCSSStyleCode(
            ".smv-slide .smv-content-zoom > .smv-zoom-view > img, .smv-slide .smv-content-spin > .smv-spin-view > img, .smv-slide .smv-content-image > img",
            "transition: opacity 0.1ms !important;"
          ),
          baseCSSStyleCode(".smv-component-loader", viewerLoadingParameters),
        ].join("\n")
      : "";
    spinLoadingStyle =
      spinLoadingParameters.length && spinLoadingParameters[0].value === "false"
        ? baseCSSStyleCode(
            ".smv-loader.spin-loader.smv-progress-loader",
            `${spinLoadingParameters[0].parameter}: none;`
          )
        : "";
    videoIconStyle = videoIconParameters.length
      ? baseCSSStyleCode(
          '.smv-thumbnails .smv-selector[data-type="video"]:before',
          videoIconParameters
        )
      : "";

    modelThumbnailStyle = modelThumbnailParameters.length
      ? baseCSSStyleCode(".Sirv", modelThumbnailParameters)
      : "";

    modelIconStyle = modelIconParameters.length
      ? baseCSSStyleCode(
          '.smv-thumbnails .smv-selector[data-type="model"]:before',
          modelIconParameters
        )
      : "";
    fullscreenBackgroundStyle = fullscreenBackgroundParameters.length
      ? baseCSSStyleCode(".smv-fullscreen-box", fullscreenBackgroundParameters)
      : "";
    videoPlayButtonStyle = videoPlayButtonParameters.length
      ? baseCSSStyleCode(
          ".smv .smv-sirv-video.video-js .vjs-big-play-button",
          videoPlayButtonParameters
        )
      : "";
    videoPlayButtonHoverStyle = videoPlayButtonHoverParameters.length
      ? baseCSSStyleCode(
          ".smv-sirv-video.video-js:hover .vjs-big-play-button,\n" +
            "  .smv-sirv-video.video-js .vjs-big-play-button:focus",
          videoPlayButtonHoverParameters
        )
      : "";

    if (hintIconsTypes === "horizontal_arrows" || hintIconsTypes === "horizontal_vertical_arrows") {
      hintIconsStyle = hintIconsParameters.length
        ? `\n${cSpace(2)}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message {` +
          `\n${cSpace(4)}display: none;` +
          `\n${cSpace(2)}}` +
          `\n${cSpace(2)}.sirv-hint.spin-hint-horizontal-animation {` +
          `\n${cSpace(4)}content:'';` +
          `\n${cSpace(4)}width: 100%;` +
          `\n${cSpace(4)}height: 90px;` +
          `\n${cSpace(4)}background-position: center;` +
          `\n${cSpace(4)}background-size: 240px auto;` +
          `\n${cSpace(4)}position: absolute;` +
          `\n${cSpace(4)}top: auto;` +
          `\n${cSpace(4)}left: 0;` +
          `\n${cSpace(4)}bottom: 0;` +
          `\n${cSpace(4)}z-index: 10;` +
          `\n${cSpace(4)}background-repeat: no-repeat;` +
          getHintCustomIconCode(hintIconsTypes) +
          `\n${cSpace(2)}}`
        : "";
    } else if (hintIconsTypes === "text_left_right") {
      hintIconsStyle = hintIconsParameters.length
        ? `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::before,\n` +
          `  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after {` +
          `\n${cSpace(4)}content:'';` +
          `\n${cSpace(4)}width: 15px;` +
          `\n${cSpace(4)}height: 10px;` +
          `\n${cSpace(4)}position: absolute;` +
          `\n${cSpace(4)}top: 50%;` +
          `\n${cSpace(4)}transform: translateY(-50%);` +
          `\n${cSpace(4)}left: 8px;` +
          getBeforeHintIconCode(hintIconsTypes) +
          `\n${cSpace(4)}background-repeat: no-repeat;` +
          `\n${cSpace(4)}background-position: center center;` +
          `\n${cSpace(4)}background-size: contain;` +
          `\n${cSpace(2)}${hintIconsParameters}` +
          `\n${cSpace(2)}}` +
          `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after {` +
          `\n${cSpace(4)}right: 8px;` +
          `\n${cSpace(4)}left: auto;` +
          `\n${cSpace(4)}top: 50%;` +
          `\n${cSpace(4)}transform: translateY(-50%) rotate(180deg);` +
          getAfterHintIconCode(hintIconsTypes) +
          `\n${cSpace(2)}}` +
          addedPaddingToHintMessageCode(hintIconsTypes) +
          getTopBottomHintIconCode(hintIconsTypes)
        : "";
    } else {
      hintIconsStyle = hintIconsParameters.length
        ? `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::before,\n` +
          `  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after {` +
          `\n${cSpace(4)}content:'';` +
          `\n${cSpace(4)}width: 15px;` +
          `\n${cSpace(4)}height: 10px;` +
          `\n${cSpace(4)}position: absolute;` +
          `\n${cSpace(4)}top: 50%;` +
          `\n${cSpace(4)}transform: translateY(-50%);` +
          `\n${cSpace(4)}left: 8px;` +
          getBeforeHintIconCode(hintIconsTypes) +
          `\n${cSpace(4)}background-repeat: no-repeat;` +
          `\n${cSpace(4)}background-position: center center;` +
          `\n${cSpace(4)}background-size: contain;` +
          `\n${cSpace(2)}${hintIconsParameters}` +
          `\n${cSpace(2)}}` +
          `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message::after {` +
          `\n${cSpace(4)}left: auto;` +
          `\n${cSpace(4)}right: 8px;` +
          `\n${cSpace(4)}transform: translateY(-50%) rotate(180deg);` +
          getAfterHintIconCode(hintIconsTypes) +
          `\n${cSpace(2)}}` +
          addedPaddingToHintMessageCode(hintIconsTypes) +
          getTopBottomHintIconCode(hintIconsTypes)
        : "";
    }

    arrowsControlStyle = arrowsControlParameters.length
      ? baseCSSStyleCode(".Sirv .smv-arrow-control", arrowsControlParameters)
      : "";
    arrowsFSControlStyle = arrowsFSControlParameters.length
      ? baseCSSStyleCode(".smv-fullscreen-box .smv-arrow-control", arrowsFSControlParameters)
      : "";
    fadeInImageSpinStyle = fadeInImageSpinStyle =
      fadeInImageSpinParameters.length && fadeInImageSpinParameters[0].value === "false"
        ? getFadeInImageSpin(fadeInImageSpinParameters[0])
        : "";
  }

  return `${fadeInImageSpinStyle}${arrowsIconStyle}${spinPosition}${arrowsIconOpacityStyle}${arrowsBorderStyle}${arrowsStyle}${thumbnailsStyle}${fullscreenIconOpenStyle}${fullscreenIconColorStyle}${fullscreenIconCloseStyle}${fullscreenIconSizeStyle}${thumbnailsItemStyle}${thumbnailsBorderRadiusStyle}${mainBorderRadiusStyle}${thumbnailsActiveItemStyle}${thumbnailsNonActiveItemStyle}${thumbnailsSMVItemStyle}${thumbnailsVideoBlurStyle}${thumbnailsSpinBlurStyle}${thumbnailsShadowStyle}${thumbnailsActiveShadowStyle}${spin360ThumbnailsWhiteStyle}${hintIconsStyle}${arrowsControlStyle}${arrowsFSControlStyle}${viewerLoadingStyle}${spinLoadingStyle}${videoIconStyle}${modelIconStyle}${modelThumbnailStyle}${modelThumbnailStyle2}${fullscreenBackgroundStyle}${videoPlayButtonStyle}${videoPlayButtonHoverStyle}`;
};

const getFadeInImageSpin = (item) => {
  return `
  .smv-slide .smv-content-image > img {
    transition: opacity 0.1ms !important;
  }
  .smv-slide .smv-content-zoom > .smv-zoom-view > img {
    transition: opacity 0.1ms !important;
  }
  .smv-slide .smv-content-spin .sirv-spin canvas {
    transition: opacity .1s ease-in;
  }`;
};

const getFadeInImageSpinWithTags = (item) => {
  return `<span class="codecssstyle">
  .smv-slide${cSpace(1)}.smv-content-image${cSpace(1)}>${cSpace(1)}img <span class="pun">{</span>
    <span class="atn">${item.parameter}</span><span class="pun">${
    item.separator
  }</span><span class="atv"> opacity 0.1ms !important;</span>
  <span class="pun">}</span>
  ${cSpace(1)}.smv-slide${cSpace(1)}.smv-content-zoom${cSpace(1)}>${cSpace(
    1
  )}.smv-zoom-view${cSpace(1)}>${cSpace(1)}img <span class="pun">{</span>
    <span class="atn">${item.parameter}</span><span class="pun">${
    item.separator
  }</span><span class="atv"> opacity 0.1ms !important;</span>
  <span class="pun">}</span>
  ${cSpace(1)}.smv-slide${cSpace(1)}.smv-content-spin${cSpace(1)}.sirv-spin${cSpace(
    1
  )}canvas <span class="pun">{</span>
    <span class="atn">${item.parameter}</span><span class="pun">${
    item.separator
  }</span><span class="atv"> opacity .1s ease-in;</span>
  <span class="pun">}</span></span>`;

  // return `${hSpace(2)}<span class="atn">${item.parameter}</span><span class="pun">${item.separator} </span><span class="atv">${item.value === 'true' ? 'inline-block' : 'none'} !important</span>;`
};

const getHintCustomIconCode = (types) => {
  let result = "";
  if (types === "horizontal_arrows") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.05.svg);`;
  }
  if (types === "horizontal_vertical_arrows") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.04.svg);`;
  }
  return result;
};

const getHintCustomIconHTML = (types) => {
  let result = "";
  if (types === "horizontal_arrows") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.05.svg)</span>;`;
  }

  if (types === "horizontal_vertical_arrows") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.04.svg)</span>;`;
  }
  return result;
};

const getBeforeHintIconCode = (types) => {
  let result = "";
  if (types === "text_left_right") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg);`;
  } else if (types === "text_round_left_right") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg);`;
  } else if (types === "text_double_left_right") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg);`;
  } else if (types === "text_left_right_up_down") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg);`;
  } else if (types === "round_text_left_right_up_down") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg);`;
  } else if (types === "double_text_left_right_up_down") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg);`;
  }
  return result;
};

const getAfterHintIconCode = (types) => {
  let result = "";
  if (types === "text_left_right") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg);`;
  } else if (types === "text_round_left_right") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg);`;
  } else if (types === "text_double_left_right") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg);`;
  } else if (types === "text_left_right_up_down") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg);`;
  } else if (types === "round_text_left_right_up_down") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg);`;
  } else if (types === "double_text_left_right_up_down") {
    result = `\n${cSpace(
      4
    )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg);`;
  }
  return result;
};

const getBeforeHintIconHTML = (types) => {
  let result = "";
  if (types === "text_left_right") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg)</span>;`;
  } else if (types === "text_round_left_right") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg)</span>;`;
  } else if (types === "text_double_left_right") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg)</span>;`;
  } else if (types === "text_left_right_up_down") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg)</span>;`;
  } else if (types === "round_text_left_right_up_down") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg)</span>;`;
  } else if (types === "double_text_left_right_up_down") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg)</span>;`;
  }
  return result;
};

const getAfterHintIconHTML = (types) => {
  let result = "";
  if (types === "text_left_right") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg)</span>;`;
  } else if (types === "text_round_left_right") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg)</span>;`;
  } else if (types === "text_double_left_right") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg)</span>;`;
  } else if (types === "text_left_right_up_down") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg)</span>;`;
  } else if (types === "round_text_left_right_up_down") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg)</span>;`;
  } else if (types === "double_text_left_right_up_down") {
    result = `\n${hSpace(
      4
    )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg)</span>;`;
  }
  return result;
};

const addedPaddingToHintMessageCode = (types) => {
  let result = "";

  if (
    types === "text_left_right" ||
    types === "text_round_left_right" ||
    types ||
    "text_double_left_right"
  ) {
    result =
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message {` +
      `\n${cSpace(4)}padding-left: 2em;` +
      `\n${cSpace(4)}padding-right: 2em;` +
      `\n${cSpace(2)}}`;
  }

  if (
    types === "text_left_right_up_down" ||
    types === "round_text_left_right_up_down" ||
    types === "double_text_left_right_up_down"
  ) {
    result =
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message {` +
      `\n${cSpace(4)}padding-left: 2em;` +
      `\n${cSpace(4)}padding-right: 2em;` +
      `\n${cSpace(4)}padding-top: 1.1em;` +
      `\n${cSpace(4)}padding-bottom: 1.1em;` +
      `\n${cSpace(2)}}`;
  }

  return result;
};

const addedPaddingToHintMessageHTML = (types) => {
  let result = "";

  if (
    types === "text_left_right" ||
    types === "text_round_left_right" ||
    types ||
    "text_double_left_right"
  ) {
    result =
      `${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">padding-left</span><span class="pun">:</span><span class="atv"> 2em</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">padding-right</span><span class="pun">:</span><span class="atv"> 2em</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>`;
  }

  if (
    types === "text_left_right_up_down" ||
    types === "round_text_left_right_up_down" ||
    types === "double_text_left_right_up_down"
  ) {
    result =
      `${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">padding-left</span><span class="pun">:</span><span class="atv"> 2em</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">padding-right</span><span class="pun">:</span><span class="atv"> 2em</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">padding-top</span><span class="pun">:</span><span class="atv"> 1.1em</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">padding-bottom</span><span class="pun">:</span><span class="atv"> 1.1em</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>`;
  }
  return result;
};

const getTopBottomHintIconCode = (types) => {
  let result = "";
  if (types === "text_left_right_up_down") {
    result +=
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::before {` +
      `\n${cSpace(4)}content:'';` +
      `\n${cSpace(4)}width: 15px;` +
      `\n${cSpace(4)}height: 15px;` +
      `\n${cSpace(4)}position: absolute;` +
      `\n${cSpace(4)}top: 2.5px;` +
      `\n${cSpace(4)}left: 50%;` +
      `\n${cSpace(
        4
      )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg);` +
      `\n${cSpace(4)}transform: translateX(-50%) rotate(90deg);` +
      `\n${cSpace(4)}background-repeat: no-repeat;` +
      `\n${cSpace(4)}background-position: center center;` +
      `\n${cSpace(4)}background-size: contain;` +
      `\n${cSpace(2)}}` +
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::after {` +
      `\n${cSpace(4)}content:'';` +
      `\n${cSpace(4)}width: 15px;` +
      `\n${cSpace(4)}height: 15px;` +
      `\n${cSpace(4)}position: absolute;` +
      `\n${cSpace(4)}bottom: 2.5px;` +
      `\n${cSpace(4)}left: 50%;` +
      `\n${cSpace(4)}transform: translateX(-50%) rotate(-90deg);` +
      `\n${cSpace(
        4
      )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg);` +
      `\n${cSpace(4)}background-repeat: no-repeat;` +
      `\n${cSpace(4)}background-position: center center;` +
      `\n${cSpace(4)}background-size: contain;` +
      `\n${cSpace(2)}}`;
  } else if (types === "round_text_left_right_up_down") {
    result +=
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::before {` +
      `\n${cSpace(4)}content:'';` +
      `\n${cSpace(4)}width: 12px;` +
      `\n${cSpace(4)}height: 12px;` +
      `\n${cSpace(4)}position: absolute;` +
      `\n${cSpace(4)}top: 2.5px;` +
      `\n${cSpace(4)}left: 50%;` +
      `\n${cSpace(4)}transform: translateX(-50%) rotate(90deg);` +
      `\n${cSpace(
        4
      )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg);` +
      `\n${cSpace(4)}background-repeat: no-repeat;` +
      `\n${cSpace(4)}background-position: center center;` +
      `\n${cSpace(4)}background-size: contain;` +
      `\n${cSpace(2)}}` +
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::after {` +
      `\n${cSpace(4)}content:'';` +
      `\n${cSpace(4)}width: 12px;` +
      `\n${cSpace(4)}height: 12px;` +
      `\n${cSpace(4)}position: absolute;` +
      `\n${cSpace(4)}bottom: 2.5px;` +
      `\n${cSpace(4)}left: 50%;` +
      `\n${cSpace(4)}transform: translateX(-50%) rotate(-90deg);` +
      `\n${cSpace(
        4
      )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg);` +
      `\n${cSpace(4)}background-repeat: no-repeat;` +
      `\n${cSpace(4)}background-position: center center;` +
      `\n${cSpace(4)}background-size: contain;` +
      `\n${cSpace(2)}}`;
  } else if (types === "double_text_left_right_up_down") {
    result +=
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::before {` +
      `\n${cSpace(4)}content:'';` +
      `\n${cSpace(4)}width: 12px;` +
      `\n${cSpace(4)}height: 12px;` +
      `\n${cSpace(4)}position: absolute;` +
      `\n${cSpace(4)}top: 2.5px;` +
      `\n${cSpace(4)}left: 50%;` +
      `\n${cSpace(4)}transform: translateX(-50%) rotate(90deg);` +
      `\n${cSpace(
        4
      )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg);` +
      `\n${cSpace(4)}background-repeat: no-repeat;` +
      `\n${cSpace(4)}background-position: center center;` +
      `\n${cSpace(4)}background-size: contain;` +
      `\n${cSpace(2)}}` +
      `\n  .sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::after {` +
      `\n${cSpace(4)}content:'';` +
      `\n${cSpace(4)}width: 12px;` +
      `\n${cSpace(4)}height: 12px;` +
      `\n${cSpace(4)}position: absolute;` +
      `\n${cSpace(4)}bottom: 2.5px;` +
      `\n${cSpace(4)}left: 50%;` +
      `\n${cSpace(4)}transform: translateX(-50%) rotate(-90deg);` +
      `\n${cSpace(
        4
      )}background-image: url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg);` +
      `\n${cSpace(4)}background-repeat: no-repeat;` +
      `\n${cSpace(4)}background-position: center center;` +
      `\n${cSpace(4)}background-size: contain;` +
      `\n${cSpace(2)}}`;
  }
  return result;
};

const getTopBottomHintIconHTML = (types) => {
  let result = "";
  if (types === "text_left_right_up_down") {
    result +=
      `\n${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::before <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 2.5px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateX(-50%) rotate(90deg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> contain</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>` +
      `\n${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::after <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">bottom</span><span class="pun">:</span><span class="atv"> 2.5px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateX(-50%) rotate(-90deg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.01.svg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> contain</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>`;
  } else if (types === "round_text_left_right_up_down") {
    result +=
      `\n${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::before <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 2.5px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateX(-50%) rotate(90deg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> contain</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>` +
      `\n${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::after <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">bottom</span><span class="pun">:</span><span class="atv"> 2.5px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateX(-50%) rotate(-90deg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.02.svg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> contain</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>`;
  } else if (types === "double_text_left_right_up_down") {
    result +=
      `\n${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::before <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 2.5px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateX(-50%) rotate(90deg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> contain</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>` +
      `\n${hSpace(
        2
      )}.sirv-hint.spin-hint-horizontal-animation .sirv-hint-message > span::after <span class="pun">{</span>` +
      `\n${hSpace(
        4
      )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 15px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">bottom</span><span class="pun">:</span><span class="atv"> 2.5px</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">left</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translateX(-50%) rotate(-90deg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-image</span><span class="pun">:</span><span class="atv"> url(https://scripts.sirv.com/sirvjs/v3/graphics/hint/hint.arrow.03.svg)</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-repeat</span><span class="pun">:</span><span class="atv"> no-repeat</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-position</span><span class="pun">:</span><span class="atv"> center center</span>;` +
      `\n${hSpace(
        4
      )}<span class="atn">background-size</span><span class="pun">:</span><span class="atv"> contain</span>;` +
      `\n${hSpace(2)}<span class="pun">}</span>`;
  }
  return result;
};

export const renderSpinButtonsStyleHTML = (position, style, background, color, size) => {
  const marginBottom = position === "onspin" ? "0" : "80px";
  const marginStyle = `\n${hSpace(
    4
  )}<span class="atn">margin-bottom</span><span class="pun">:</span><span class="atv"> ${marginBottom}</span>;`;

  const computedPosition = position === "onspin" ? "absolute" : "relative";
  const positionStyle = `\n${hSpace(
    4
  )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> ${computedPosition}</span>;`;

  let iconsFontStyle = "";

  if (style === "material") {
    iconsFontStyle = "Material Icons";
  }
  if (style === "fontawesome") {
    iconsFontStyle = "FontAwesome";
  }

  const fontFamilyStyle = iconsFontStyle.length
    ? `\n${hSpace(
        4
      )}<span class="atn">font-family</span><span class="pun">:</span><span class="atv"> '${iconsFontStyle}'</span>;`
    : ``;

  return (
    `<span class="codecssstyle">\n${hSpace(2)}.viewer <span class="pun">{</span>` +
    `\n${hSpace(
      4
    )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> relative</span>;` +
    marginStyle +
    `\n${hSpace(2)}<span class="pun">}</span></span>` +
    `<span class="codecssstyle">\n${hSpace(2)}.spin-buttons <span class="pun">{</span>` +
    positionStyle +
    `\n${hSpace(
      4
    )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 100%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">bottom</span><span class="pun">:</span><span class="atv"> 0</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">min-height</span><span class="pun">:</span><span class="atv"> 80px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">z-index</span><span class="pun">:</span><span class="atv"> 2</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">background-color</span><span class="pun">:</span><span class="atv"> ${background}</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">display</span><span class="pun">:</span><span class="atv"> flex</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">align-items</span><span class="pun">:</span><span class="atv"> center</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">justify-content</span><span class="pun">:</span><span class="atv"> space-evenly</span>;` +
    fontFamilyStyle +
    `\n${hSpace(2)}<span class="pun">}</span></span>` +
    `<span class="codecssstyle">\n${hSpace(2)}.spin-buttons > div <span class="pun">{</span>` +
    `\n${hSpace(
      4
    )}<span class="atn">cursor</span><span class="pun">:</span><span class="atv"> pointer</span>;` +
    `\n${hSpace(2)}<span class="pun">}</span></span>` +
    `<span class="codecssstyle">\n${hSpace(2)}.spin-buttons > div,` +
    `\n${hSpace(2)}.spin-buttons > div::before<span class="pun">{</span>` +
    `\n${hSpace(
      4
    )}<span class="atn">font-size</span><span class="pun">:</span><span class="atv"> ${size}px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">color</span><span class="pun">:</span><span class="atv"> ${color}</span>;` +
    `\n${hSpace(2)}<span class="pun">}</span></span>` +
    `<span class="codecssstyle">\n${hSpace(2)}#info <span class="pun">{</span>` +
    `\n${hSpace(
      4
    )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">right</span><span class="pun">:</span><span class="atv"> 0</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> -40px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">max-width</span><span class="pun">:</span><span class="atv"> 150px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 100%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">min-height</span><span class="pun">:</span><span class="atv"> 40px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">background-color</span><span class="pun">:</span><span class="atv"> ${background}</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">color</span><span class="pun">:</span><span class="atv"> ${color}</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">display</span><span class="pun">:</span><span class="atv"> flex</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">align-items</span><span class="pun">:</span><span class="atv"> center</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">justify-content</span><span class="pun">:</span><span class="atv"> center</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">font-family</span><span class="pun">:</span><span class="atv"> 'Source Sans Pro', sans-serif</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">font-size</span><span class="pun">:</span><span class="atv"> 16px</span>;` +
    `\n${hSpace(2)}<span class="pun">}</span></span>`
  );
};

export const codeSpinButtonsStyleHTML = (position, style, background, color, size) => {
  const marginBottom = position === "onspin" ? "0" : "80px";
  const marginStyle = `\n${cSpace(4)}margin-bottom:${cSpace(1)}${marginBottom};`;

  const computedPosition = position === "onspin" ? "absolute" : "relative";
  const positionStyle = `\n${cSpace(4)}position:${cSpace(1)}${computedPosition};`;

  let iconsFontStyle = "";

  if (style === "material") {
    iconsFontStyle = "Material Icons";
  }
  if (style === "fontawesome") {
    iconsFontStyle = "FontAwesome";
  }

  const fontFamilyStyle = iconsFontStyle.length
    ? `\n${cSpace(4)}font-family:${cSpace(1)}'${iconsFontStyle}';`
    : ``;

  return (
    `\n${cSpace(2)}.viewer${cSpace(1)}{` +
    `\n${cSpace(4)}position:${cSpace(1)}relative;` +
    marginStyle +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.spin-buttons${cSpace(1)}{` +
    positionStyle +
    `\n${cSpace(4)}width:${cSpace(1)}100%;` +
    `\n${cSpace(4)}bottom:${cSpace(1)}0;` +
    `\n${cSpace(4)}min-height:${cSpace(1)}80px;` +
    `\n${cSpace(4)}z-index:${cSpace(1)}2;` +
    `\n${cSpace(4)}background-color:${cSpace(1)}${background};` +
    `\n${cSpace(4)}display:${cSpace(1)}flex;` +
    `\n${cSpace(4)}align-items:${cSpace(1)}center;` +
    `\n${cSpace(4)}justify-content:${cSpace(1)}space-evenly;` +
    fontFamilyStyle +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.spin-buttons > div${cSpace(1)}{` +
    `\n${cSpace(4)}cursor:${cSpace(1)}pointer;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.spin-buttons > div,` +
    `\n${cSpace(2)}.spin-buttons > div::before${cSpace(1)}{` +
    `\n${cSpace(4)}font-size:${cSpace(1)}${size}px;` +
    `\n${cSpace(4)}color:${cSpace(1)}${color};` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}#info${cSpace(1)}{` +
    `\n${cSpace(4)}position:${cSpace(1)}absolute;` +
    `\n${cSpace(4)}right:${cSpace(1)}0;` +
    `\n${cSpace(4)}top:${cSpace(1)}-40px;` +
    `\n${cSpace(4)}max-width:${cSpace(1)}150px;` +
    `\n${cSpace(4)}width:${cSpace(1)}100%;` +
    `\n${cSpace(4)}min-height:${cSpace(1)}40px;` +
    `\n${cSpace(4)}background-color:${cSpace(1)}${background};` +
    `\n${cSpace(4)}color:${cSpace(1)}${color};` +
    `\n${cSpace(4)}display:${cSpace(1)}flex;` +
    `\n${cSpace(4)}align-items:${cSpace(1)}center;` +
    `\n${cSpace(4)}justify-content:${cSpace(1)}center;` +
    `\n${cSpace(4)}font-family:${cSpace(1)}'Source Sans Pro', sans-serif;` +
    `\n${cSpace(4)}font-size:${cSpace(1)}16px;` +
    `\n${cSpace(2)}}`
  );
};

export const arrowsCSS = () => {
  return (
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> relative</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">transition</span><span class="pun">:</span><span class="atv"> opacity .2s ease</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv"> .000001</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow::before,${cSpace(1)}.smv-h${cSpace(
      1
    )}.smv-arrow::after${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">display</span><span class="pun">:</span><span class="atv"> block</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">content</span><span class="pun">:</span><span class="atv"> ''</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">position</span><span class="pun">:</span><span class="atv"> absolute</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">background-color</span><span class="pun">:</span><span class="atv"> transparent</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">border</span><span class="pun">:</span><span class="atv"> 3px solid transparent</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">border-radius</span><span class="pun">:</span><span class="atv"> 5px 5px 0 0</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">height</span><span class="pun">:</span><span class="atv"> 22%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">top</span><span class="pun">:</span><span class="atv"> 50%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">right</span><span class="pun">:</span><span class="atv"> 20%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translate(-50%, -99.2%) skewX(40deg)</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">width</span><span class="pun">:</span><span class="atv"> 4px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">z-index</span><span class="pun">:</span><span class="atv"> 1</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">box-sizing</span><span class="pun">:</span><span class="atv"> content-box !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow::before${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">border-bottom</span><span class="pun">:</span><span class="atv"> none</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow::after${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">border-top</span><span class="pun">:</span><span class="atv"> none</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">transform</span><span class="pun">:</span><span class="atv"> translate(-50%, -.8%) skewX(-40deg)</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">border-radius</span><span class="pun">:</span><span class="atv"> 0 0 5px 5px</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-arrow${cSpace(1)}.smv-icon${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">-webkit-mask-repeat</span><span class="pun">:</span><span class="atv"> none !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">mask-repeat</span><span class="pun">:</span><span class="atv"> none !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">-webkit-mask-position</span><span class="pun">:</span><span class="atv"> none !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">mask-position</span><span class="pun">:</span><span class="atv"> none !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">-webkit-mask-size</span><span class="pun">:</span><span class="atv"> none !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">-webkit-mask-image</span><span class="pun">:</span><span class="atv"> none !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">background</span><span class="pun">:</span><span class="atv"> transparent !important</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">z-index</span><span class="pun">:</span><span class="atv">  2</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">position</span><span class="pun">:</span><span class="atv">  static !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-arrow${cSpace(1)}.smv-icon::before,${cSpace(1)}.smv-arrow${cSpace(
      1
    )}.smv-icon::after${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">display</span><span class="pun">:</span><span class="atv">  block</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">content</span><span class="pun">:</span><span class="atv">  ''</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">position</span><span class="pun">:</span><span class="atv">  absolute</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">background</span><span class="pun">:</span><span class="atv">  #999</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">border-radius</span><span class="pun">:</span><span class="atv">  5px 5px 0 0</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">height</span><span class="pun">:</span><span class="atv">  22%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">top</span><span class="pun">:</span><span class="atv">  50%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">right</span><span class="pun">:</span><span class="atv">  20%</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">transform</span><span class="pun">:</span><span class="atv">  translate(-50%, -99.2%) skewX(40deg)</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">width</span><span class="pun">:</span><span class="atv">  5px</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">z-index</span><span class="pun">:</span><span class="atv">  2</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">margin</span><span class="pun">:</span><span class="atv">  0 4px</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-arrow${cSpace(1)}.smv-icon::before${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">border-bottom</span><span class="pun">:</span><span class="atv">  none</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-arrow${cSpace(1)}.smv-icon::after${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">border-top</span><span class="pun">:</span><span class="atv">  none</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">transform</span><span class="pun">:</span><span class="atv">  translate(-50%, -.8%) skewX(-40deg)</span>;` +
    `\n${hSpace(
      4
    )}<span class="atn">border-radius</span><span class="pun">:</span><span class="atv">  0 0 5px 5px</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow-prev${cSpace(1)}.smv-icon${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">transform</span><span class="pun">:</span><span class="atv">  none !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow-prev.smv-arrow${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">transform</span><span class="pun">:</span><span class="atv">  scaleX(-1) !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow.smv-arrow-thumbnails${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv">  1</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow.smv-arrow-thumbnails::before,${cSpace(
      1
    )}.smv-h${cSpace(1)}.smv-arrow.smv-arrow-thumbnails::after${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">display</span><span class="pun">:</span><span class="atv">  none</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-h${cSpace(1)}.smv-arrow.smv-arrow-thumbnails${cSpace(
      1
    )}.smv-icon::before,${cSpace(1)}.smv-h${cSpace(1)}.smv-arrow.smv-arrow-thumbnails${cSpace(
      1
    )} .smv-icon::after${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">right</span><span class="pun">:</span><span class="atv">  2px</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-arrow${cSpace(1)}.smv-icon${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv">  1 !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-slides-box:hover${cSpace(1)}.smv-arrow${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv">  .4 !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}.smv-slides-box:hover${cSpace(1)}.smv-arrow:hover${cSpace(1)}{` +
    `\n${hSpace(
      4
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv">  1 !important</span>;` +
    `\n${cSpace(2)}}` +
    `\n${cSpace(2)}@media${cSpace(1)} screen${cSpace(1)}and${cSpace(1)}(max-width:${cSpace(
      1
    )}768px)${cSpace(1)}{` +
    `\n${cSpace(4)}.smv-h${cSpace(1)}.smv-arrow${cSpace(1)}{` +
    `\n${hSpace(
      6
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv">  1 !important</span>;` +
    `\n${cSpace(4)}}` +
    `\n${cSpace(4)}.smv-slides-box:hover${cSpace(1)}.smv-arrow${cSpace(1)}{` +
    `\n${hSpace(
      6
    )}<span class="atn">opacity</span><span class="pun">:</span><span class="atv">  1 !important</span>;` +
    `\n${cSpace(4)}}` +
    `\n${cSpace(2)}}`
  );
};

export const imageFadeIn = () => {
  return (
    `\n${cSpace(2)}.smv-slide${cSpace(1)}.smv-content-zoom${cSpace(1)}>${cSpace(
      1
    )}.smv-zoom-view${cSpace(1)}>${cSpace(1)}img,` +
    `\n${cSpace(2)}.smv-slide${cSpace(1)}.smv-content-spin${cSpace(1)}>${cSpace(
      1
    )}.smv-spin-view${cSpace(1)}>${cSpace(1)}img,` +
    `\n${cSpace(2)}.smv-slide${cSpace(1)}.smv-content-image${cSpace(1)}>${cSpace(1)}img${cSpace(
      1
    )}{` +
    `\n${hSpace(
      4
    )}<span class="atn">transition</span><span class="pun">:</span><span class="atv"> opacity 0.1ms !important</span>;` +
    `\n${cSpace(2)}}`
  );
};
